//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
import userChecks from '~/mixins/userChecks';
import { formatDate, convertDuration } from '@/helpers/filters.js';
export default {
  mixins: [ImageSrcsetMixin, userChecks],
  async fetch() {
    this.$store.commit('mxmStore/clearStream');

    const resource = await this.$store.dispatch('resourcesStore/getResource', {
      slug: this.$route.params.slug,
      query: this.queries.video,
      checkAccess: this.$auth.loggedIn,
    });

    const resourceId = resource.id;

    if (
      this.$auth.loggedIn &&
      resource.product === 'paid' &&
      resource.status === 'published'
    ) {
      await this.$store.dispatch('resourcesStore/checkResourceAccess', {
        id: resourceId,
        type: this.queries.video.content,
      });
    } else if (resource.product === 'free') {
      this.$store.commit('resourcesStore/setAccess', {
        access: true,
        subscription: [],
        type: 'video',
      });
    }
    await Promise.all([
      this.$store.dispatch('bannerStore/getBanner', 'resource'),
      this.$store.dispatch('resourcesStore/countResource', {
        id: this.$route.params.slug,
      }),
    ]);
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.phone && to.query.phone == 'succes') {
      next((vm) => {
        var phone_stream_id = vm.getCookie('phone_stream_id');
        if (phone_stream_id) {
          vm.$store.dispatch(
            'ppmStore/checkPhoneStreamStatus',
            phone_stream_id
          );
        }
      });
    } else if (to.query.paywall && to.query.paywall == 'active') {
      next((vm) => {
        vm.$store.commit('paywallStore/setView', 'active');
      });
    } else {
      next((vm) => {
        var phone_stream_id = vm.getCookie('phone_stream_id');
        if (phone_stream_id) {
          vm.$store.dispatch(
            'ppmStore/checkPhoneStreamStatus',
            phone_stream_id
          );
        }
      });
    }
  },
  beforeDestroy() {
    this.$store.commit('resourcesStore/resetAccess');
  },
  data() {
    return {
      favorite: false,
      kind: false,
    };
  },
  head() {
    return {
      title: this.video.title
        ? this.video.title + ' | Sexfilm | ' + process.env.APP_TITLE
        : 'Sexfilm | Meiden van Holland',
      link: [
        {
          rel:
            this.video.product &&
            this.video.product.id == 1 &&
            this.video.slug == this.$route.params.slug
              ? 'canonical'
              : '',
          href:
            this.video.product &&
            this.video.product.id == 1 &&
            this.video.slug == this.$route.params.slug
              ? 'https://meidenvanholland.nl/gratis-sexfilms/' + this.video.slug
              : '',
        },
      ],
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: this.video.title
            ? this.video.title + ' | Sexfilm | ' + process.env.APP_TITLE
            : 'Sexfilm | Meiden van Holland',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            this.video &&
            this.video.seo &&
            this.video.seo &&
            this.video.seo.description
              ? this.video.seo.description
              : 'Geile Meiden van Holland Sexfilm',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            this.video && this.video.seo && this.video.seo
              ? this.video.seo.keywords
              : 'Sexfilm, Meiden, Holland',
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.video.title
            ? this.video.title + ' | Sexfilm | ' + process.env.APP_TITLE
            : 'Sexfilm | Meiden van Holland',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            this.video &&
            this.video.seo &&
            this.video.seo &&
            this.video.seo.description
              ? this.video.seo.description
              : 'Geile Meiden van Holland Sexfilm',
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content:
            this.video && this.video.seo && this.video.seo
              ? process.env.FE_URL + '/gratis-sexfilms/' + this.video.slug
              : '',
        },
        { hid: 'og:type', name: 'og:type', content: 'video.movie' },
        {
          hid: 'og:video',
          name: 'og:video',
          content: this.video.title
            ? process.env.FE_URL + '/gratis-sexfilms/' + this.video.slug
            : '',
        },
        {
          hid: 'og:video:type',
          name: 'og:video:type',
          content: 'application/x-mpegurl',
        },
        { hid: 'og:video:width', name: 'og:video:width', content: '1920' },
        { hid: 'og:video:height', name: 'og:video:height', content: '1080' },
        {
          hid: 'og:duration',
          name: 'og:duration',
          content: this.video && this.video.seconds ? this.video.seconds : '',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content:
            this.video && this.video.thumb
              ? process.env.CDN + this.video.thumb.l
              : '',
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content:
            this.video && this.video.seo && this.video.seo
              ? process.env.FE_URL + '/gratis-sexfilms/' + this.video.slug
              : '',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content:
            this.video && this.video.title
              ? this.video.title + ' | Sexfilm | ' + process.env.APP_TITLE
              : 'Sexfilm | Meiden van Holland',
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content:
            this.video &&
            this.video.seo &&
            this.video.seo &&
            this.video.seo.description
              ? this.video.seo.description
              : 'Geile Meiden van Holland Sexfilm',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content:
            this.video && this.video.thumb
              ? process.env.CDN + this.video.thumb.l
              : '',
        },
      ],
      script: [
        {
          json: {
            '@context': 'http://schema.org',
            '@type': 'VideoObject',
            name: this.video
              ? this.video.title
              : 'Sexfilm | Meiden van Holland',
            description:
              this.video &&
              this.video.seo &&
              this.video.seo &&
              this.video.seo.description
                ? this.video.seo.description
                : 'Geile Meiden van Holland Sexfilm',
            thumbnailUrl:
              this.video && this.video.thumb
                ? process.env.CDN + this.video.thumb.l
                : '',
            uploadDate:
              this.video && this.video.uploadDate ? this.video.uploadDate : '',
            duration:
              this.video && this.video.isoDuration
                ? this.video.isoDuration
                : '',
            embedUrl: this.video
              ? process.env.FE_URL + '/gratis-sexfilms/' + this.video.slug
              : '',
          },
          type: 'application/ld+json',
        },
      ],
    };
  },
  components: {
    dummy: () => import('~/components/content/dummy/detailed_dummy.vue'),
    breadcrumbs: () => import('~/components/breadcrumbs'),
    getAccess: () => import('~/components/get_access'),
    dateviews: () => import('~/components/date_views'),
    description: () => import('~/components/DescriptionResources'),
    categories: () => import('~/components/content/video/info/categories'),
    models: () => import('~/components/content/video/info/models'),
    recurring: () => import('~/components/content/video/info/recurring'),
    ppmButton: () => import('~/components/content/video/info/ppm_button'),
    maxXsPlayer: () => import('~/components/maxxXsPlayer'),
    gallery: () => import('~/components/content/video/gallery_video'),
    RelatedResources: () => import('~/components/RelatedResources'),
    banner: () => import('~/components/banner.vue'),
    CreditsIcon: () => import('@/assets/svg/icon_credits.svg'),
    Paywall: () => import('~/components/payment/module.vue'),
    error: () => import('~/components/error.vue'),
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: { queries } }) => queries,
      access: ({ resourcesStore: { access } }) => access,
      video: ({ resourcesStore: { video } }) => video,
      loading: ({ resourcesStore: { loading } }) => loading,
      playerOptions: ({ mxmStore: { playerOptions } }) => playerOptions,
      stream: ({ mxmStore: { stream } }) => stream,
      killStream: ({ mxmStore: { killStream } }) => killStream,
      playerState: ({ mxmStore: { playerState } }) => playerState,
      preroll: (state) => state.mxmStore.preroll,
      modal: ({ modalStore: { modal } }) => modal,
    }),
    choosePlaybutton() {
      if (
        (this.playerState.type == 'film' &&
          this.access.access &&
          this.playerState.status != 'exit' &&
          this.playerState.status != 'pause' &&
          this.video.videos.data.film &&
          this.video.videos.data.film[0].id) ||
        (!this.playerState.type &&
          this.access.access &&
          this.playerState.status != 'exit' &&
          this.playerState.status != 'pause' &&
          this.video.videos.data.film &&
          this.video.videos.data.film[0].id)
      ) {
        return 'paidFilm';
      } else if (
        (this.playerState.type == 'film' &&
          this.access.access &&
          this.playerState.status != 'exit' &&
          !this.video.videos.data.film &&
          this.video.videos.data.free_film &&
          this.video.videos.data.free_film[0].id) ||
        (!this.playerState.type &&
          this.access.access &&
          this.playerState.status != 'exit' &&
          !this.video.videos.data.film &&
          this.video.videos.data.free_film &&
          this.video.videos.data.free_film[0].id)
      ) {
        return 'freeFilm';
      }
    },
  },
  watch: {
    access: function () {
      this.$auth.fetchUser();
      this.checkPaywall();
      console.log('access has changed so refresh the user');
    },
    preroll: function (newValue, oldValue) {
      if (newValue === 'shown') {
        this.loadFreeFilm(this.video.videos.data.free_film[0].id);
      }
    },
    'playerState.type': function (newVal, oldVal) {
      console.log(newVal);
    },
    stream: function () {
      if (
        this.stream.location == 'sexfilm' &&
        this.stream.ITEM &&
        this.stream.ITEM.LINKS
      ) {
        if (
          this.video.images &&
          this.video.images.data &&
          this.video.images.data.thumb &&
          this.video.images.data.thumb[0]
        ) {
          var thumb = this.$config.cdn + this.video.images.data.thumb[0].path;
        } else {
          var thumb = this.$config.cdn + this.$config.errorimg;
        }
        let playerOptions = {
          autoplay: true,
          poster: thumb,
        };
        this.$store.commit('mxmStore/updatePlayerOptions', playerOptions);
        this.$store.commit('mxmStore/setPlayerType', this.stream.type);

        var phone_stream_id = this.getCookie('phone_stream_id');
        if (phone_stream_id) {
          // PPM access so we should check status with interval
          // Interval is handled by mxmStore
          var dataObj = {
            action: 'update',
            stream_id: phone_stream_id,
          };
          this.$store.dispatch('mxmStore/startUpdateStream', dataObj);
        }
      }
    },
    killStream: function () {
      var phone_stream_id = this.getCookie('phone_stream_id');
      if (this.killStream == true && phone_stream_id) {
        this.doKillStream('phone');
      }
    },
    video: function () {
      this.checkPaywall();
      var phone_stream_id = this.getCookie('phone_stream_id');
      if (phone_stream_id) {
        this.$store.dispatch(
          'ppmStore/checkPhoneStreamStatus',
          phone_stream_id
        );
      }
    },
  },
  mounted() {
    this.checkPaywall();
  },
  methods: {
    formatDate,
    convertDuration,
    checkPaywall() {
      if (this.$route.params.slug != this.video.slug) {
        return;
      }
      if (!this.access.access && window.innerWidth < 992) {
        this.$store.commit('paywallStore/setView', 'active');
        this.$store.commit('paywallStore/setStep', 0);
      } else {
        this.$store.commit('paywallStore/setView', 'closed');
      }
    },
    checkFavorite() {
      if (this.$auth.loggedIn && this.hasFavoriteResource('video')) {
        var self = this;
        this.userFavoriteResources('video').forEach(function (favorite) {
          if (self.video.id === favorite.id) {
            self.favorite = true;
          }
        });
      }
    },
    loadTrailer(videoId) {
      this.$store.commit('mxmStore/clearStream');
      this.kind = false;
      var dataObj = [];
      dataObj.video_id = videoId;
      dataObj.resource_id = this.video.id;
      dataObj.product_type = 'free';
      dataObj.type = 'trailer';
      dataObj.location = 'sexfilm';
      this.$store.dispatch('mxmStore/getStream', dataObj);
    },
    async loadFreeFilm(videoId) {
      this.$store.commit('mxmStore/clearStream');
      this.kind = false;
      if (this.stream && this.stream.id && this.stream.type == 'free_film') {
        return this.$store.commit('mxmStore/setPlayerStatus', 'playing');
      }
      if (this.stream && this.stream.id && this.stream.type == 'trailer') {
        this.trailer = false;
      }
      if (
        (this.video.product === 'free' &&
          this.$auth.loggedIn &&
          !this.hasDirectSubscription() &&
          this.preroll != 'shown') ||
        (this.video.product === 'free' &&
          !this.$auth.loggedIn &&
          this.preroll != 'shown')
      ) {
        const preroll = await this.$store.dispatch(
          'resourcesStore/getResources',
          this.queries.preroll
        );
        if (preroll && preroll.data.length) {
          const randomIndex = Math.floor(Math.random() * preroll.data.length);
          var dataObj = {
            video_id: preroll.data[randomIndex].videos.data.preroll[0].id,
            resource_id: preroll.data[randomIndex].id,
            href: preroll.data[randomIndex].extra.href,
            target: preroll.data[randomIndex].extra.target,
            type: 'preroll',
            location: 'sexfilm',
            product_type: 'free',
          };
          return this.$store.dispatch('mxmStore/getStream', dataObj);
        }
      }

      var dataObj = {
        video_id: videoId,
        resource_id: this.video.id,
        type: 'free_film',
        location: 'sexfilm',
        product_type: 'free',
      };
      if (this.$store.state.auth.loggedIn) {
        dataObj.user_id = this.$auth.user.id;
      }
      this.$store.dispatch('mxmStore/getStream', dataObj);
    },
    loadPaidFilm(videoId) {
      this.$store.commit('mxmStore/clearStream');
      this.kind = false;
      if (this.stream && this.stream.id && this.stream.type == 'film') {
        return this.$store.commit('mxmStore/setPlayerStatus', 'playing');
      }
      var dataObj = {
        video_id: videoId,
        resource_id: this.video.id,
        type: 'film',
        location: 'sexfilm',
        product_type: 'paid',
      };
      if (this.$store.state.auth.loggedIn) {
        dataObj.user_id = this.$store.state.auth.user.id;
      }

      var phone_stream_id = this.getCookie('phone_stream_id');
      if (phone_stream_id) {
        dataObj.phone_stream_id = phone_stream_id;
        dataObj.subscription_id = 3;
        return this.$store.dispatch('mxmStore/getStream', dataObj);
      } else {
        dataObj.subscription_id = this.access.subscription.id
          ? this.access.subscription.id
          : 1;
        return this.$store.dispatch('mxmStore/getStream', dataObj);
      }
    },
    setStatus(status) {
      this.$store.commit('mxmStore/setPlayerStatus', status);
    },
    doKillStream(type) {
      if (type == 'phone') {
        var alertObj = [];
        alertObj.type = 'warning';
        alertObj.message =
          'De verbinding is verbroken. Verder kijken? Bel dan opnieuw.';
        this.$store.commit('alertStore/setAlert', alertObj, { root: true });
        document.cookie =
          'phone_stream_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        this.$store.commit('resourcesStore/setAccess', {
          access: false,
          is_free: false,
          subscription: [],
        });
        this.$store.commit('mxmStore/clearStream');
        this.$store.commit('ppmStore/setPpmStatus', false);
      }
    },
  },
};
